//#region types
import { AuthEnums } from "models/enums";
//#endregion
import useAPIClientHelper from "./useAPIClientHelper";

function usePreliminaryTaxUpdateService() {
  const { apiClientInstance } = useAPIClientHelper();

  const accept = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).PreliminaryTaxUpdateClient.Accept(id);
  };

  const decline = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).PreliminaryTaxUpdateClient.Decline(id);
  };

  return {
    accept,
    decline,
  };
}

export default usePreliminaryTaxUpdateService;
